import React, { Component } from "react";

import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";

import CreateNewItem from "./CreateNewItem";
import SearchItem from "./SearchItem";
import _ from "lodash";

type Props = {
  onToggleDialog: () => void;
  onCreateItem: Function;
  itemSelected: string;
  onSetItem: Function;
  dataset: Array<any>;
  isOpen: boolean;
  entity: string;
  mode: string;
  canCreateNewItem: boolean;
  showDataset: boolean;
};

type State = {
  itemSelected: string;
  dataset: Array<any>;
};

class DialogChooseItem extends Component<Props, State> {
  state = {
    itemSelected: null,
    dataset: [],
  };

  componentDidMount() {
    const { itemSelected, dataset } = this.props;

    this.setState({
      itemSelected,
      dataset,
    });
  }

  componentDidUpdate(prevProps) {
    const { itemSelected, dataset } = this.props;
    // Check for changes in props and update state accordingly
    if (
      itemSelected !== prevProps.itemSelected ||
      !_.isEqual(dataset, prevProps.dataset)
    ) {
      this.setState({
        itemSelected,
        dataset,
      });
    }
  }

  onSelectItem = (indexItemSelected: number): void => {
    const { dataset } = this.state;
    const { showDataset } = this.props;

    this.setState({
      itemSelected: !!showDataset
        ? dataset[indexItemSelected]
        : dataset[indexItemSelected].name,
    });
  };

  onCreateItem = (item: string): void => {
    const { onCreateItem } = this.props;
    const { dataset } = this.state;

    this.setState(
      {
        dataset: [item, ...dataset],
        itemSelected: item,
      },
      () => onCreateItem(item)
    );
  };

  renderSlide = (props): any => <Slide direction="up" {...props} />;

  renderCreateNewItem = () => {
    const { dataset } = this.state;
    const { entity } = this.props;

    console.log("Entity", entity);
    const titles = {
      categoryName: {
        placeholder: "Ingresa el nombre de la nueva categoría",
        panelTitle: "Registra una nueva categoría",
      },
      tags: {
        placeholder: "Ingresa el nombre de la etiqueta",
        panelTitle: "Registra una nueva etiqueta",
      },
    };

    return (
      <CreateNewItem
        placeholder={titles[entity].placeholder}
        panelTitle={titles[entity].panelTitle}
        onCreateItem={this.onCreateItem}
        dataset={dataset}
        entity={entity}
      />
    );
  };

  renderSearchInputItem = () => {
    const { itemSelected, dataset } = this.state;
    const { entity, showDataset } = this.props;

    return (
      <SearchItem
        onSelectItem={this.onSelectItem}
        itemSelected={!!showDataset ? itemSelected?.name : itemSelected}
        options={dataset}
        entity={entity}
      />
    );
  };

  renderDialogActionButtons = () => {
    const { onToggleDialog, onSetItem } = this.props;
    const { itemSelected } = this.state;

    return (
      <DialogActions>
        <Button onClick={onToggleDialog} color="primary">
          Cancel
        </Button>
        <Button
          onClick={() => onSetItem(itemSelected)}
          disabled={!itemSelected}
          color="primary"
        >
          Ok
        </Button>
      </DialogActions>
    );
  };

  render() {
    const { onToggleDialog, entity, isOpen, mode, canCreateNewItem } =
      this.props;

    const titles = {
      categoryName: "Categoría",
      tags: "Etiqueta",
    };

    const actionTitle = mode === "edit" ? "Editar" : "Seleccionar";
    const entityTitle = titles[entity];

    return (
      <Dialog
        aria-describedby="alert-dialog-slide-description"
        aria-labelledby="alert-dialog-slide-title"
        TransitionComponent={this.renderSlide}
        onClose={onToggleDialog}
        disableBackdropClick
        open={isOpen}
        maxWidth="sm"
        keepMounted
        fullWidth
      >
        <DialogTitle id="alert-dialog-slide-title">
          {`${actionTitle} ${entityTitle}`}
        </DialogTitle>
        <DialogContent>
          {this.renderSearchInputItem()}
          {!!canCreateNewItem && this.renderCreateNewItem()}
        </DialogContent>
        {this.renderDialogActionButtons()}
      </Dialog>
    );
  }
}

export default DialogChooseItem;
